import { render, staticRenderFns } from "./PatientEncountersModal.vue?vue&type=template&id=8a91622e&"
import script from "./PatientEncountersModal.vue?vue&type=script&lang=js&"
export * from "./PatientEncountersModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports